module.exports = __webpack_public_path__ + "img/C.25595a9e.webp";